import { useMemo } from "react";
import { useFetchObjectives } from "../../../../api/okr/objective";
import { SelectField } from "../../../../components/fields/SelectField";
import useAccountId from "../../../../hooks/customDomainHooks";
import { formatOkrOptions } from "../../../OKRV2/Objectives/formatOkrOptions";

const OkrWidgetConfig = () => {
  const { accountId } = useAccountId();
  const { data: objectiveSets, isLoading: isLoadingObjectives } =
    useFetchObjectives(accountId, null, "timePeriod.startDate.desc", []);

  const objectiveOptions = useMemo(
    () => formatOkrOptions(objectiveSets),
    [objectiveSets]
  );

  return (
    <>
      <SelectField
        field={{
          id: "data",
          label: "Objective",
          validation: { required: true },
        }}
        isLoading={isLoadingObjectives}
        options={objectiveOptions}
      />
    </>
  );
};

export default OkrWidgetConfig;
